<template>
    <div class="form-edit-page">
        <div class="page-header">
            <h1>Cadastro de Elementos de Controle / Inspeção</h1>
            <p>
                Cadastro de itens de verificação por classificação de inspeção.
            </p>
        </div>

        <div class="form-card">
            <div class="row">
                <div class="field-group field-md">
                    <label>Classificação</label>
                    <select v-model="objEdicao.classificacao">
                        <option value="">Selecione</option>
                        <option
                            v-for="item in lsClassificacoes"
                            :key="item.id"
                            :value="item.id"
                        >
                            {{ item.nome }}
                        </option>
                    </select>
                </div>

                <div class="field-group field-sm">
                    <label>Ordem</label>
                    <input
                        type="number"
                        v-model="objEdicao.ordem"
                        min="1"
                    />
                </div>

                <div class="field-group field-md">
                    <label>Tipo de Resposta</label>
                    <select v-model="objEdicao.tipoResposta">
                        <option value="">Selecione</option>
                        <option value="CHECK">Checklist (Sim/Não)</option>
                        <option value="TEXTO">Texto</option>
                        <option value="NUMERO">Número</option>
                        <option value="DATA">Data</option>
                        <option value="OPCOES">Opções</option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="field-group field-lg">
                    <label>Descrição do Elemento de Controle</label>
                    <input
                        type="text"
                        v-model="objEdicao.descricao"
                        maxlength="250"
                        placeholder="Ex.: Temperatura da câmara fria está adequada?"
                    />
                </div>
            </div>

            <div class="row">
                <div class="field-group field-lg">
                    <label>Orientação / Critério de Avaliação</label>
                    <textarea
                        v-model="objEdicao.orientacao"
                        rows="3"
                        maxlength="500"
                        placeholder="Ex.: Verificar se a temperatura encontra-se dentro do limite aceitável conforme procedimento interno."
                    ></textarea>
                </div>
            </div>

            <div class="row">
                <div class="field-group field-md">
                    <label>Base Legal / Referência</label>
                    <input
                        type="text"
                        v-model="objEdicao.baseLegal"
                        maxlength="200"
                        placeholder="Ex.: RIISPOA / Norma Interna / POP"
                    />
                </div>

                <div class="field-group field-sm checkbox-group">
                    <label class="checkbox-inline">
                        <input type="checkbox" v-model="objEdicao.obrigatorio" />
                        Obrigatório
                    </label>
                </div>

                <div class="field-group field-sm checkbox-group">
                    <label class="checkbox-inline">
                        <input type="checkbox" v-model="objEdicao.ativo" />
                        Ativo
                    </label>
                </div>
            </div>

            <div class="row row-actions">
                <button class="btn btn-primary" @click="adicionarItem">
                    Adicionar à Lista
                </button>
                <button class="btn btn-secondary" @click="limparFormulario">
                    Limpar
                </button>
            </div>

            <div v-if="msgErro" class="alert alert-error">
                {{ msgErro }}
            </div>
        </div>

        <div class="grid-card">
            <div class="grid-header">
                <h2>Itens Cadastrados na Tela</h2>
                <span>{{ lsItens.length }} item(ns)</span>
            </div>

            <div v-if="lsItens.length === 0" class="empty-state">
                Nenhum elemento de controle informado até o momento.
            </div>

            <div v-else class="table-wrapper">
                <table class="data-table">
                    <thead>
                        <tr>
                            <th style="width: 80px;">Ordem</th>
                            <th style="width: 220px;">Classificação</th>
                            <th>Descrição</th>
                            <th style="width: 170px;">Tipo</th>
                            <th style="width: 110px;">Obrig.</th>
                            <th style="width: 90px;">Ativo</th>
                            <th style="width: 90px;">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in lsItens" :key="item.uid">
                            <td>{{ item.ordem }}</td>
                            <td>{{ getNomeClassificacao(item.classificacao) }}</td>
                            <td>
                                <div class="item-main">{{ item.descricao }}</div>
                                <div v-if="item.orientacao" class="item-sub">
                                    {{ item.orientacao }}
                                </div>
                                <div v-if="item.baseLegal" class="item-sub item-legal">
                                    Ref.: {{ item.baseLegal }}
                                </div>
                            </td>
                            <td>{{ getNomeTipoResposta(item.tipoResposta) }}</td>
                            <td>{{ item.obrigatorio ? 'Sim' : 'Não' }}</td>
                            <td>{{ item.ativo ? 'Sim' : 'Não' }}</td>
                            <td>
                                <button
                                    class="btn-action btn-remove"
                                    @click="removerItem(index)"
                                >
                                    Excluir
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { reactive, ref } from 'vue';

export default {
    name: 'ElementoControleForm',
    setup() {
        const lsClassificacoes = ref([
            { id: 'CARNES', nome: 'Carnes e derivados' },
            { id: 'LEITE', nome: 'Leite e derivados' },
            { id: 'MEL', nome: 'Mel e produtos apícolas' },
            { id: 'OVOS', nome: 'Ovos e derivados' },
            { id: 'PESCADO', nome: 'Pescado e derivados' },
        ]);

        const objEdicao = reactive(novoItem());
        const lsItens = ref(mockElementos);
        const msgErro = ref('');

        function novoItem() {
            return {
                uid: null,
                classificacao: '',
                ordem: '',
                descricao: '',
                orientacao: '',
                tipoResposta: 'CHECK',
                baseLegal: '',
                obrigatorio: true,
                ativo: true,
            };
        }

        function limparFormulario() {
            Object.assign(objEdicao, novoItem());
            msgErro.value = '';
        }

        function validarFormulario() {
            if (!objEdicao.classificacao) {
                throw new Error('Informe a classificação.');
            }

            if (!objEdicao.ordem || Number(objEdicao.ordem) <= 0) {
                throw new Error('Informe uma ordem válida.');
            }

            if (!objEdicao.descricao || !objEdicao.descricao.trim()) {
                throw new Error('Informe a descrição do elemento de controle.');
            }

            if (!objEdicao.tipoResposta) {
                throw new Error('Informe o tipo de resposta.');
            }
        }

        function adicionarItem() {
            try {
                msgErro.value = '';
                validarFormulario();

                lsItens.value.push({
                    uid: Date.now() + Math.random(),
                    classificacao: objEdicao.classificacao,
                    ordem: Number(objEdicao.ordem),
                    descricao: objEdicao.descricao.trim(),
                    orientacao: objEdicao.orientacao?.trim() || '',
                    tipoResposta: objEdicao.tipoResposta,
                    baseLegal: objEdicao.baseLegal?.trim() || '',
                    obrigatorio: !!objEdicao.obrigatorio,
                    ativo: !!objEdicao.ativo,
                });

                lsItens.value.sort((a, b) => {
                    if (a.classificacao < b.classificacao) return -1;
                    if (a.classificacao > b.classificacao) return 1;
                    return a.ordem - b.ordem;
                });

                limparFormulario();
                objEdicao.tipoResposta = 'CHECK';
                objEdicao.obrigatorio = true;
                objEdicao.ativo = true;
            } catch (error) {
                msgErro.value = error.message || 'Erro ao adicionar item.';
            }
        }

        function removerItem(index) {
            lsItens.value.splice(index, 1);
        }

        function getNomeClassificacao(id) {
            const item = lsClassificacoes.value.find(a => a.id === id);
            return item ? item.nome : id;
        }

        function getNomeTipoResposta(tipo) {
            if (tipo === 'CHECK') return 'Checklist (Sim/Não)';
            if (tipo === 'TEXTO') return 'Texto';
            if (tipo === 'NUMERO') return 'Número';
            if (tipo === 'DATA') return 'Data';
            if (tipo === 'OPCOES') return 'Opções';
            return tipo;
        }

        return {
            objEdicao,
            lsClassificacoes,
            lsItens,
            msgErro,
            limparFormulario,
            adicionarItem,
            removerItem,
            getNomeClassificacao,
            getNomeTipoResposta,
        };
    },
};

const mockElementos = [
    // =========================
    // CARNES
    // =========================
    {
        uid: 1,
        classificacao: 'CARNES',
        ordem: 1,
        descricao: 'Temperatura da câmara fria está adequada?',
        orientacao: 'Verificar se a temperatura está entre 0°C e 4°C.',
        tipoResposta: 'CHECK',
        baseLegal: 'RIISPOA',
        obrigatorio: true,
        ativo: true,
    },
    {
        uid: 2,
        classificacao: 'CARNES',
        ordem: 2,
        descricao: 'Equipamentos higienizados corretamente?',
        orientacao: 'Avaliar presença de resíduos orgânicos e limpeza geral.',
        tipoResposta: 'CHECK',
        baseLegal: 'Manual de Boas Práticas',
        obrigatorio: true,
        ativo: true,
    },
    {
        uid: 3,
        classificacao: 'CARNES',
        ordem: 3,
        descricao: 'Registro de controle de abate atualizado?',
        orientacao: '',
        tipoResposta: 'CHECK',
        baseLegal: '',
        obrigatorio: false,
        ativo: true,
    },

    // =========================
    // LEITE
    // =========================
    {
        uid: 4,
        classificacao: 'LEITE',
        ordem: 1,
        descricao: 'Controle de pasteurização realizado?',
        orientacao: 'Verificar registros e temperatura do processo.',
        tipoResposta: 'CHECK',
        baseLegal: 'IN 76/2018',
        obrigatorio: true,
        ativo: true,
    },
    {
        uid: 5,
        classificacao: 'LEITE',
        ordem: 2,
        descricao: 'Temperatura do leite armazenado (°C)',
        orientacao: 'Informar temperatura atual do tanque.',
        tipoResposta: 'NUMERO',
        baseLegal: '',
        obrigatorio: true,
        ativo: true,
    },
    {
        uid: 6,
        classificacao: 'LEITE',
        ordem: 3,
        descricao: 'Observações sobre qualidade do leite',
        orientacao: '',
        tipoResposta: 'TEXTO',
        baseLegal: '',
        obrigatorio: false,
        ativo: true,
    },

    // =========================
    // MEL
    // =========================
    {
        uid: 7,
        classificacao: 'MEL',
        ordem: 1,
        descricao: 'Local de extração adequado?',
        orientacao: 'Verificar limpeza, proteção contra contaminantes.',
        tipoResposta: 'CHECK',
        baseLegal: 'MAPA',
        obrigatorio: true,
        ativo: true,
    },
    {
        uid: 8,
        classificacao: 'MEL',
        ordem: 2,
        descricao: 'Filtragem do mel realizada corretamente?',
        orientacao: '',
        tipoResposta: 'CHECK',
        baseLegal: '',
        obrigatorio: true,
        ativo: true,
    },
    {
        uid: 9,
        classificacao: 'MEL',
        ordem: 3,
        descricao: 'Tipo de processamento do mel',
        orientacao: '',
        tipoResposta: 'OPCOES',
        baseLegal: '',
        obrigatorio: false,
        ativo: true,
    },

    // =========================
    // OVOS
    // =========================
    {
        uid: 10,
        classificacao: 'OVOS',
        ordem: 1,
        descricao: 'Classificação dos ovos realizada?',
        orientacao: 'Verificar categorização por tamanho e qualidade.',
        tipoResposta: 'CHECK',
        baseLegal: '',
        obrigatorio: true,
        ativo: true,
    },
    {
        uid: 11,
        classificacao: 'OVOS',
        ordem: 2,
        descricao: 'Condições de armazenamento',
        orientacao: 'Temperatura e ambiente controlado.',
        tipoResposta: 'TEXTO',
        baseLegal: '',
        obrigatorio: false,
        ativo: true,
    },

    // =========================
    // PESCADO
    // =========================
    {
        uid: 12,
        classificacao: 'PESCADO',
        ordem: 1,
        descricao: 'Temperatura no transporte adequada?',
        orientacao: 'Verificar uso de gelo ou refrigeração.',
        tipoResposta: 'CHECK',
        baseLegal: '',
        obrigatorio: true,
        ativo: true,
    },
    {
        uid: 13,
        classificacao: 'PESCADO',
        ordem: 2,
        descricao: 'Presença de sinais de deterioração?',
        orientacao: 'Odor, coloração e textura.',
        tipoResposta: 'CHECK',
        baseLegal: '',
        obrigatorio: true,
        ativo: true,
    },
    {
        uid: 14,
        classificacao: 'PESCADO',
        ordem: 3,
        descricao: 'Data da inspeção',
        orientacao: '',
        tipoResposta: 'DATA',
        baseLegal: '',
        obrigatorio: true,
        ativo: true,
    },
];
</script>

<style scoped>
.form-edit-page {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    background: #f5f7fa;
}

.page-header h1 {
    margin: 0 0 6px 0;
    font-size: 24px;
    color: #1f2937;
}

.page-header p {
    margin: 0;
    color: #6b7280;
}

.form-card,
.grid-card {
    background: #ffffff;
    border: 1px solid #dbe3ea;
    border-radius: 10px;
    padding: 18px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 14px;
}

.field-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.field-group label {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
}

.field-group input,
.field-group select,
.field-group textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #cfd8e3;
    border-radius: 8px;
    font-size: 14px;
    background: #fff;
    box-sizing: border-box;
}

.field-group textarea {
    resize: vertical;
    min-height: 90px;
}

.field-sm {
    flex: 1 1 140px;
}

.field-md {
    flex: 1 1 260px;
}

.field-lg {
    flex: 1 1 100%;
}

.checkbox-group {
    justify-content: flex-end;
}

.checkbox-inline {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 42px;
    font-weight: 500;
}

.row-actions {
    margin-top: 4px;
    margin-bottom: 0;
}

.btn {
    border: none;
    border-radius: 8px;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
}

.btn-primary {
    background: #2563eb;
    color: #fff;
}

.btn-secondary {
    background: #e5e7eb;
    color: #374151;
}

.alert {
    margin-top: 14px;
    padding: 12px;
    border-radius: 8px;
    font-size: 14px;
}

.alert-error {
    background: #fef2f2;
    color: #b91c1c;
    border: 1px solid #fecaca;
}

.grid-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
}

.grid-header h2 {
    margin: 0;
    font-size: 18px;
    color: #1f2937;
}

.grid-header span {
    font-size: 13px;
    color: #6b7280;
}

.empty-state {
    padding: 20px;
    text-align: center;
    color: #6b7280;
    background: #f9fafb;
    border: 1px dashed #d1d5db;
    border-radius: 8px;
}

.table-wrapper {
    overflow-x: auto;
}

.data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.data-table thead th {
    text-align: left;
    background: #f3f4f6;
    color: #374151;
    padding: 10px;
    border-bottom: 1px solid #d1d5db;
}

.data-table tbody td {
    padding: 10px;
    border-bottom: 1px solid #e5e7eb;
    vertical-align: top;
}

.item-main {
    font-weight: 600;
    color: #111827;
    margin-bottom: 4px;
}

.item-sub {
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 3px;
}

.item-legal {
    font-style: italic;
}

.btn-action {
    border: none;
    border-radius: 6px;
    padding: 6px 10px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
}

.btn-remove {
    background: #fee2e2;
    color: #b91c1c;
}

@media (max-width: 900px) {
    .row {
        flex-direction: column;
    }

    .field-sm,
    .field-md,
    .field-lg {
        flex: 1 1 100%;
    }

    .grid-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
    }
}
</style>